<template>
  <v-tooltip
    :disabled="tooltip === ''"
    bottom
    open-delay="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :value="badgeText"
        :content="badgeText"
        bottom
        overlap
      >
        <v-avatar
          :size="size"
          :color="color"
          :style="{ color: textColor, '--fontSize': `${fontSize}px` }"
          :rounded="square ? true : '3px'"
          class="avatarClass"
          v-bind="attrs"
          v-on="on"
        >
          <span class="avatarText">
            {{ text }}
          </span>
        </v-avatar>
      </v-badge>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>
<script>
export default {
  name: 'AvatarComponent',
  props: {
    size: {
      type: [Number, String],
      default: 18,
    },
    color: {
      type: String,
      default: 'grey',
    },
    textColor: {
      type: String,
      default: 'white',
    },
    text: {
      type: [String, Number],
      default: '',
    },
    square: {
      type: Boolean,
      default: false,
    },
    badgeText: {
      type: [Number, String],
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  computed: {
    fontSize() {
      return Math.ceil(this.size / 4 + 5);
    },
  },
};
</script>
<style scoped>
.avatarText {
  font-size: var(--fontSize);
}
/*
.avatarClass:hover {
  cursor: pointer;
}
*/
</style>
